import {
  Box,
  Button,
  Card,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Menu,
  MenuItem,
  Modal,
  Pagination,
  PaginationItem,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import DesignerHeader from "components/designerHeader";
import DesignerSidebar from "components/desingerSidebar";
import DesignerFooter from "components/designerFooter";
import {
  arrowBackwardIcon,
  arrowForwardIcon,
  closeIcon,
  editBlueIcon,
  editGreenIcon,
  editIcon,
  editPurpleIcon,
  editYellowIcon,
  filterLightIcon,
  filterPrimaryIcon,
  noteIcon,
  saveIcon,
  courseListSecondaryIcon,
} from "assets/images";
import React from "react";
import { Link } from "react-router-dom";

function ArrowBackIcon() {
  return <img src={arrowBackwardIcon} alt="arrow-backward" />;
}
function ArrowForwardIcon() {
  return <img src={arrowForwardIcon} alt="arrow-forward" />;
}

interface Data {
  slpnum: number;
  studentName: string;
  status: string;
  assignedOn: string;
  assignedBy: string;
  allocatedTo: string;
  dueDate: string;
  slpParticipation: string;
  contactProgress: string;
}

interface CompletedSLPData {
  slpnum: number;
  studentName: string;
  status: string;
  allocatedTo: string;
  dateOfRequest: string;
  dateCompleted: string;
}

function createData(
  slpnum: number,
  studentName: string,
  status: string,
  assignedOn: string,
  assignedBy: string,
  allocatedTo: string,
  dueDate: string,
  slpParticipation: string,
  contactProgress: string
): Data {
  return {
    slpnum,
    studentName,
    status,
    assignedOn,
    assignedBy,
    allocatedTo,
    dueDate,
    slpParticipation,
    contactProgress,
  };
}

const rows = [
  createData(
    1,
    "Jacquelin E. Bellido",
    "pending",
    "10 Nov 2022",
    "Alex Lin",
    "Alex Li",
    "20, Apr. 2025",
    "Active btn",
    "Not Started"
  ),
  createData(
    2,
    "Tessa V. Rebecchi",
    "in-progress",
    "10 Nov 2022",
    "-",
    "-",
    "20, Apr. 2025",
    "Active btn",
    "Assigned"
  ),
  createData(
    3,
    "Tessa V. Rebecchi",
    "in-progress",
    "10 Nov 2022",
    "-",
    "-",
    "20, Apr. 2025",
    "Active btn",
    "In Progress"
  ),
];

function createCompletedSLPData(
  slpnum: number,
  studentName: string,
  status: string,
  dateOfRequest: string,
  dateCompleted: string,
  allocatedTo: string
): CompletedSLPData {
  return {
    slpnum,
    studentName,
    status,
    dateOfRequest,
    dateCompleted,
    allocatedTo,
  };
}

const completedSLPRows = [
  createCompletedSLPData(
    2,
    "Annette Black",
    "completed",
    "10 Nov 2022",
    "10 Nov 2022",
    "Alex Li"
  ),
  createCompletedSLPData(
    4,
    "Robert Fox",
    "completed",
    "03 Nov 2022",
    "03 Nov 2022",
    "Rachael Rogan"
  ),
];

const renderContactProgress = (status: string, onClick?: () => void) => {
  let icon = editYellowIcon;
  let className = "default";

  switch (status) {
    case "Not Started":
      icon = editYellowIcon;
      className = "not-started";
      break;
    case "Assigned":
      icon = editGreenIcon;
      className = "assigned";
      break;
    case "In Progress":
      icon = editBlueIcon;
      className = "in-progress";
      break;
    case "Active":
      icon = editPurpleIcon;
      className = "active";
      break;
    default:
      icon = editYellowIcon; // fallback
      className = "default";
  }

  return (
    <Button
      className={`btn-progress ${className}`}
      variant="outlined"
      onClick={onClick}
    >
      <img src={icon} alt="Icon" />
      <Typography variant="body2" className="w-auto">
        {status}
      </Typography>
    </Button>
  );
};

const DesignerSlpDashboard: React.FC = () => {
  // Pagination State
  const [page, setPage] = React.useState("5");

  const handleChange = (event: SelectChangeEvent) => {
    setPage(event.target.value as string);
  };

  // SLP Participation Modal State
  const [reset, setReset] = React.useState(false);
  const handleReset = () => setReset(true);
  const handleResetClose = () => setReset(false);

  // Select1 State
  const [select1, setSelect1] = React.useState("active");

  const handleSelect1Change = (event: SelectChangeEvent) => {
    setSelect1(event.target.value as string);
  };

  // Contact Progress Modal State
  const [progress, setProgress] = React.useState(false);
  const handleProgress = () => setProgress(true);
  const handleProgressClose = () => setProgress(false);

  // Select2 State
  const [select2, setSelect2] = React.useState("not-started");

  const handleSelect2Change = (event: SelectChangeEvent) => {
    setSelect2(event.target.value as string);
  };

  // Export Menu State
  const [exportMenu, setExportMenu] = React.useState<null | HTMLElement>(null);
  const exportOpen = Boolean(exportMenu);
  const handleExportClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setExportMenu(event.currentTarget);
  };
  const handleExportClose = () => {
    setExportMenu(null);
  };

  // Contact Notes Modal State
  const [notes, setNotes] = React.useState(false);
  const handleNotes = () => setNotes(true);
  const handleNotesClose = () => setNotes(false);

  return (
    <div className="wrapper">
      <Box
        className="overlay"
        onClick={() => document.body.classList.toggle("sidebar-toggle")}
      />
      <DesignerHeader />
      <main>
        <DesignerSidebar />
        <div className="main-content">
          <Box className="content-header">
            <Typography variant="h2" className="heading">
              SLP Dashboard
            </Typography>
          </Box>
          <Grid
            container
            spacing={{ xs: "16px", lg: "20px", xl: "24px" }}
            className="content-container"
          >
            {/* Top Card */}
            <Grid item xs={12}>
              <Card>
                <Box className="table-card-header">
                  <Typography variant="h3">
                    Search Student Profiles & SLP Request
                  </Typography>
                  <Box>
                    <TextField
                      id="search"
                      variant="outlined"
                      className="search-input"
                      placeholder="Search"
                      defaultValue="Search Student"
                    />

                    <Button
                      id="export-btn"
                      aria-controls={exportOpen ? "export-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={exportOpen ? "true" : undefined}
                      onClick={handleExportClick}
                      disableElevation
                      variant="outlined"
                      className="btn-export"
                    >
                      Export
                    </Button>
                    <Menu
                      id="export-menu"
                      anchorEl={exportMenu}
                      open={exportOpen}
                      onClose={handleExportClose}
                      MenuListProps={{
                        "aria-labelledby": "export-button",
                      }}
                      className="export-menu"
                      disableScrollLock
                    >
                      <MenuItem title="Excel" onClick={handleExportClose}>
                        <Button>Excel</Button>
                      </MenuItem>
                      <MenuItem title="PDF" onClick={handleExportClose}>
                        <Button>PDF</Button>
                      </MenuItem>
                    </Menu>

                    <Button variant="outlined" className="btn-filter">
                      <img
                        src={filterPrimaryIcon}
                        alt="filter"
                        className="default"
                      />
                      <img
                        src={filterLightIcon}
                        alt="filter"
                        className="active"
                      />
                      <span>Filter</span>
                    </Button>
                  </Box>
                </Box>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="center"
                          sx={{
                            maxWidth: "84px",
                            width: "84px",
                            minWidth: "84px",
                          }}
                        >
                          SLP Number
                        </TableCell>
                        <TableCell sx={{ width: "154px", minWidth: "154px" }}>
                          Student Name
                        </TableCell>
                        <TableCell align="center" sx={{ width: "120px" }}>
                          SLP Status
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ width: "120px", minWidth: "120px" }}
                        >
                          Assigned On
                        </TableCell>
                        <TableCell sx={{ width: "120px", minWidth: "120px" }}>
                          Assigned By
                        </TableCell>
                        <TableCell sx={{ width: "120px", minWidth: "120px" }}>
                          Allocated To
                        </TableCell>
                        <TableCell sx={{ width: "120px", minWidth: "120px" }}>
                          Due Date
                        </TableCell>
                        <TableCell
                          sx={{ width: "120px", minWidth: "120px" }}
                          align="center"
                        >
                          SLP Participation
                        </TableCell>
                        <TableCell
                          sx={{ width: "130px", minWidth: "130px" }}
                          align="center"
                        >
                          Contact Progress
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ width: "100px", minWidth: "100px" }}
                        >
                          Contact Notes
                        </TableCell>
                        <TableCell align="center" sx={{ width: "92px" }}>
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map((row) => (
                        <TableRow key={row.slpnum}>
                          <TableCell component="th" scope="row" align="center">
                            {row.slpnum}
                          </TableCell>
                          <TableCell>
                            <a href="-">
                              <Typography variant="body2">
                                {row.studentName}
                              </Typography>
                            </a>
                          </TableCell>
                          <TableCell
                            align="center"
                            className={`${row.status} status`}
                          >
                            <div>{row.status}</div>
                          </TableCell>
                          <TableCell align="center">{row.assignedOn}</TableCell>
                          <TableCell>
                            <Typography variant="body2">
                              {row.assignedBy}
                            </Typography>
                          </TableCell>
                          <TableCell>{row.allocatedTo}</TableCell>
                          <TableCell>{row.dueDate}</TableCell>
                          <TableCell align="center">
                            <Button
                              className="btn-progress active"
                              variant="outlined"
                              onClick={handleReset}
                            >
                              <img src={editPurpleIcon} alt="Icon" />
                              <Typography variant="body2">Active</Typography>
                            </Button>
                          </TableCell>
                          <TableCell align="center">
                            {renderContactProgress(
                              row.contactProgress,
                              handleProgress
                            )}
                          </TableCell>
                          <TableCell align="center">
                            <div className="table-actions">
                              <IconButton onClick={handleNotes}>
                                <img src={noteIcon} alt="Icon" />
                              </IconButton>
                            </div>
                          </TableCell>
                          <TableCell align="center">
                            <div className="table-actions">
                              <IconButton
                                component={Link}
                                to="designer-student-profile-details"
                              >
                                <img
                                  src={courseListSecondaryIcon}
                                  alt="View"
                                  style={{ height: "17px", width: "17px" }}
                                />
                              </IconButton>
                              <IconButton>
                                <img src={editIcon} alt="Edit" />
                              </IconButton>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Box className="custom-pagination">
                  <Box className="custom-rowperpage">
                    <Typography variant="body2" component="span">
                      Page:
                    </Typography>
                    <Select
                      id="pagination-select"
                      value={page}
                      onChange={handleChange}
                      MenuProps={{
                        className: "pagination-menu",
                      }}
                    >
                      <MenuItem value={5} selected>
                        5
                      </MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={15}>15</MenuItem>
                      <MenuItem value={20}>20</MenuItem>
                      <MenuItem value={25}>25</MenuItem>
                      <MenuItem value={30}>30</MenuItem>
                    </Select>
                    <Typography variant="body2" component="span">
                      Showing 10 - 20 of 50 entries
                    </Typography>{" "}
                  </Box>
                  <Pagination
                    count={5}
                    variant="outlined"
                    shape="rounded"
                    renderItem={(item) => (
                      <PaginationItem
                        slots={{
                          previous: ArrowBackIcon,
                          next: ArrowForwardIcon,
                        }}
                        {...item}
                      />
                    )}
                  />
                </Box>
              </Card>
            </Grid>
            {/* Bottom Card */}
            <Grid item xs={12}>
              <Card>
                <Box className="table-card-header">
                  <Typography variant="h3">Completed SLPs</Typography>
                  <Box>
                    <TextField
                      id="search"
                      variant="outlined"
                      className="search-input"
                      placeholder="Search"
                    />

                    <Button variant="outlined" className="btn-export">
                      Export
                    </Button>

                    <Button variant="outlined" className="btn-filter">
                      <img
                        src={filterPrimaryIcon}
                        alt="filter"
                        className="default"
                      />
                      <img
                        src={filterLightIcon}
                        alt="filter"
                        className="active"
                      />
                      <span>Filter</span>
                    </Button>
                  </Box>
                </Box>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="center"
                          sx={{
                            maxWidth: "70px",
                            width: "70px",
                            minWidth: "70px",
                          }}
                        >
                          SLP Number
                        </TableCell>
                        <TableCell sx={{ width: "130px", minWidth: "130px" }}>
                          Student Name
                        </TableCell>
                        <TableCell sx={{ width: "90px" }} align="center">
                          SLP Status
                        </TableCell>
                        <TableCell sx={{ width: "140px", minWidth: "140px" }}>
                          Date of Request
                        </TableCell>
                        <TableCell sx={{ width: "140px", minWidth: "140px" }}>
                          Date Completed
                        </TableCell>
                        <TableCell sx={{ width: "130px", minWidth: "130px" }}>
                          Allocated To
                        </TableCell>
                        <TableCell align="center" sx={{ width: "92px" }}>
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {completedSLPRows.map((row) => (
                        <TableRow key={row.slpnum}>
                          <TableCell component="th" scope="row" align="center">
                            {row.slpnum}
                          </TableCell>
                          <TableCell>
                            <a href="-">
                              <Typography variant="body2">
                                {row.studentName}
                              </Typography>
                            </a>
                          </TableCell>
                          <TableCell
                            align="center"
                            className={`${row.status} status`}
                          >
                            <div>{row.status}</div>
                          </TableCell>
                          <TableCell>{row.dateOfRequest}</TableCell>
                          <TableCell>
                            <Typography variant="body2">
                              {row.dateCompleted}
                            </Typography>
                          </TableCell>
                          <TableCell>{row.allocatedTo}</TableCell>
                          <TableCell align="center">
                            <div className="table-actions">
                              <IconButton>
                                <img
                                  src={courseListSecondaryIcon}
                                  alt="edit"
                                  style={{ height: "17px", width: "17px" }}
                                />
                              </IconButton>
                              <IconButton>
                                <img src={editIcon} alt="Edit" />
                              </IconButton>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Box className="custom-pagination">
                  <Box className="custom-rowperpage">
                    <Typography variant="body2" component="span">
                      Page:
                    </Typography>
                    <Select
                      id="pagination-select"
                      value={page}
                      onChange={handleChange}
                      MenuProps={{
                        className: "pagination-menu",
                      }}
                    >
                      <MenuItem value={5} selected>
                        5
                      </MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={15}>15</MenuItem>
                      <MenuItem value={20}>20</MenuItem>
                      <MenuItem value={25}>25</MenuItem>
                      <MenuItem value={30}>30</MenuItem>
                    </Select>
                    <Typography variant="body2" component="span">
                      Showing 10 - 20 of 50 entries
                    </Typography>{" "}
                  </Box>
                  <Pagination
                    count={5}
                    variant="outlined"
                    shape="rounded"
                    renderItem={(item) => (
                      <PaginationItem
                        slots={{
                          previous: ArrowBackIcon,
                          next: ArrowForwardIcon,
                        }}
                        {...item}
                      />
                    )}
                  />
                </Box>
              </Card>
            </Grid>
          </Grid>
          <DesignerFooter />
        </div>
      </main>

      {/* SLP Participation Modal */}
      <Modal open={reset} onClose={handleResetClose}>
        <Box className="common-modal modal-400">
          <Box className="modal-header">
            <Typography variant="h4">SLP Participation</Typography>
            <IconButton onClick={handleResetClose}>
              <img src={closeIcon} alt="close" />
            </IconButton>
          </Box>
          <Box className="modal-body">
            <Grid container columnSpacing="16px">
              <Grid item xs>
                <FormControl fullWidth className="select">
                  <InputLabel id="course1-label">Status</InputLabel>
                  <Select
                    labelId="course1-label"
                    id="course1"
                    label="Course"
                    value={select1}
                    onChange={handleSelect1Change}
                  >
                    <MenuItem value="active">Active</MenuItem>
                    <MenuItem value="not required">
                      No Further SLP Required
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
          <Box className="modal-footer">
            <Button
              variant="contained"
              className="btn-save"
              onClick={handleResetClose}
            >
              <img src={saveIcon} alt="save" />
              Save
            </Button>
            <Button
              variant="outlined"
              className="btn-cancel"
              onClick={handleResetClose}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Contact Progress Modal */}
      <Modal open={progress} onClose={handleProgressClose}>
        <Box className="common-modal modal-400">
          <Box className="modal-header">
            <Typography variant="h4">Contact Progress</Typography>
            <IconButton onClick={handleProgressClose}>
              <img src={closeIcon} alt="close" />
            </IconButton>
          </Box>
          <Box className="modal-body">
            <Grid container columnSpacing="16px">
              <Grid item xs>
                <FormControl fullWidth className="select">
                  <InputLabel id="course1-label">Status</InputLabel>
                  <Select
                    label="Status"
                    value={select2}
                    onChange={handleSelect2Change}
                  >
                    <MenuItem value="not-started">Not Started</MenuItem>
                    <MenuItem value="in-progress">In Progress</MenuItem>
                    <MenuItem value="assigned">Assigned</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
          <Box className="modal-footer">
            <Button
              variant="contained"
              className="btn-save"
              onClick={handleProgressClose}
            >
              <img src={saveIcon} alt="save" />
              Save
            </Button>
            <Button
              variant="outlined"
              className="btn-cancel"
              onClick={handleProgressClose}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Contact Notes Modal */}
      <Modal open={notes} onClose={handleNotesClose}>
        <Box className="common-modal modal-600">
          <Box className="modal-header">
            <Typography variant="h4">Contact Notes</Typography>
            <IconButton onClick={handleNotesClose}>
              <img src={closeIcon} alt="close" />
            </IconButton>
          </Box>
          <Box className="modal-body">
            <Grid container columnSpacing="16px">
              <Grid item xs>
                <TextField
                  className="skills-textarea"
                  label="Contact Note"
                  fullWidth
                  variant="outlined"
                  multiline
                />
              </Grid>
            </Grid>
          </Box>
          <Box className="modal-footer">
            <Button
              variant="contained"
              className="btn-save"
              onClick={handleNotesClose}
            >
              <img src={saveIcon} alt="save" />
              Save
            </Button>
            <Button
              variant="outlined"
              className="btn-cancel"
              onClick={handleNotesClose}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};
export default DesignerSlpDashboard;
